import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListingStatus } from '../../../types';

const STYLE: Record<ListingStatus, string> = {
  published: 'border-ink bg-ink text-paper',
  pending: 'border-ink text-ink',
  draft: 'border-dashed border-ink/30 text-ink/70',
  hidden: 'border-dashed border-ink/30 text-ink/70',
  rejected: 'border-danger-600 text-danger-600',
  deleted: 'border-danger-600 bg-danger-600 text-paper',
};

/** Status for the super admin, published included (the public tag hides "Published"). */
export function SuperStatusTag({ status }: { status: ListingStatus }) {
  const { t } = useTranslation();
  return (
    <span className={`shrink-0 inline-flex items-center text-xs px-2 py-0.5 rounded-[10px] font-medium border ${STYLE[status] ?? STYLE.draft}`}>
      {t(`directory.listingStatus.${status}`)}
    </span>
  );
}
